import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Tooltip, Tag } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import './emoji-mart.css'
import { Picker } from 'emoji-mart'
import './dart_internal.css'
import { MentionsInput, Mention } from 'react-mentions'
import { uuidv4, handleFormat, sendNotification, getFileType, getFileName } from '../../utils'
import UploadFile from '../../utils/UploadFile'
import MainAudioRecorder from './MainAudioRecorder'
import { MAX_FILE_COMMENTS_IN_BYTES, MAX_FILE_COMMENTS_IN_MB } from '../../utils/Constants/UploadsConstants'
import AttachedFileProgress from "./AttachedFileProgress"
import { 
  setIsDoingACommentWithFile,
  unsetIsDoingACommentWithFile,
  unsetIsImageTagActive,
  unsetIsVideoTagActive,
  unsetIsAudioTagActive } from "../../actions/CommentAction"

// import AttachIcon from './AttachIcon'

import { KEY_CODE_ENTER } from "../../utils";
import DinamicPdfTag from "./PdfTag/DinamicPdfTag";
import AudioTag from "./AudioTag/AudioTag";
import ImageTag from "./ImageTag/ImageTag";
import VideoTagV2 from "./VideoTagV2/VideoTagV2";

export class MainCommentsTopInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultAvatar: "/images/icons/user-icon.svg",
      recommendedText: false,
      showPickerEmoji: {
        show: false,
        isMain: true,
        commentId: null
      },
      attachedFile: null,
      isUploadingFile: false,
      isRecording: false,
      isWriting: true
    };
    this.uploadInputRef = React.createRef();
  }

  componentDidMount() {
    const { avatar } = this.props;

    if (avatar) {
      this.setState({
        defaultAvatar: avatar
      });
    }

    if (this.refs.commentRef) {
      const inputDartMain = ReactDOM.findDOMNode(
        this.refs.commentRef
      ).getElementsByClassName("dart-input-text__input");
      if (inputDartMain.length > 0) inputDartMain[0].removeAttribute("style");
      const highlighterDartMain = ReactDOM.findDOMNode(
        this.refs.commentRef
      ).getElementsByClassName("dart-input-text__highlighter");
      if (highlighterDartMain.length > 0)
        highlighterDartMain[0].removeAttribute("style");
    }
  }

  componentDidUpdate() {
    if (this.refs.commentRef) {
      const inputDartMain = ReactDOM.findDOMNode(
        this.refs.commentRef
      ).getElementsByClassName("dart-input-text__input");
      if (inputDartMain.length > 0) inputDartMain[0].removeAttribute("style");
      const highlighterDartMain = ReactDOM.findDOMNode(
        this.refs.commentRef
      ).getElementsByClassName("dart-input-text__highlighter");
      if (highlighterDartMain.length > 0)
        highlighterDartMain[0].removeAttribute("style");
    }
  }
  /**TOP COMMENTS */

  addEmojiToComment = item => {
    this.props.addEmojiToComment(item);

    if (this.refs.commentRef) {
      const inputDartMain = ReactDOM.findDOMNode(
        this.refs.commentRef
      ).getElementsByClassName("dart-input-text__input");
      if (inputDartMain.length > 0) inputDartMain[0].focus();
    }
  };

  selectRecommendedText = (item, isMain) => {
    if (isMain) {
      this.props.selectRecommendedText(item, isMain);
      if (this.refs.commentRef) {
        const inputDartMain = ReactDOM.findDOMNode(
          this.refs.commentRef
        ).getElementsByClassName("dart-input-text__input");
        if (inputDartMain.length > 0) inputDartMain[0].focus();
      }
    }
  };

  changePickerEmojiComments = (isMain, commentId = null, show = null) => {
    const { showPickerEmoji } = this.state;
    this.setState(
      {
        showPickerEmoji: {
          show:
            show === null
              ? showPickerEmoji.isMain === isMain
                ? !showPickerEmoji.show
                : true
              : show,
          isMain,
          commentId
        }
      },
      () => {
        if (isMain) ReactDOM.findDOMNode(this.refs.divdartpickeremoji).focus();
      }
    );
  };

  closeAll = e => {
    if (!this.props.focusInCurrentTarget(e))
      this.setState(state => ({
        recommendedText: false,
        showPickerEmoji: {
          ...state.showPickerEmoji,
          show: false
        }
      }));
  };

  closeEmojiPicker = e => {
    this.setState(state => ({
      showPickerEmoji: {
        ...state.showPickerEmoji,
        show: false
      }
    }));
  };

  handleSelectFile = e => {
    const { intl } = this.props;
    const { length } = e.target.files;
    e.persist();
    const firstFilePosition = 0;
    if (
      length > 0 &&
      e.target.files[firstFilePosition].size <= MAX_FILE_COMMENTS_IN_BYTES
    ) {
      const ext = e.target.files[firstFilePosition].name.split(".").slice(-1);
      const uuid = uuidv4();
      const s3Name = `${uuid}.${ext}`;
      const newFile = {
        uuid,
        s3Name,
        ext,
        applyRkg: true,
        uploadObject: null,
        file: e.target.files[firstFilePosition],
        name: e.target.files[firstFilePosition].name,
        size: e.target.files[firstFilePosition].size,
        sizeFormat: handleFormat(e.target.files[firstFilePosition].size),
        type: e.target.files[firstFilePosition].type,
        state: "waiting",
        progress: 0
      };
      let reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[firstFilePosition]);
      reader.onloadend = file => {
        if (file.total === 0) {
          console.log("problemas leyendo ");
        } else {
          this.setState({ attachedFile: newFile });
        }
      };
    } else if (
      e.target.files[firstFilePosition] &&
      e.target.files[firstFilePosition].size > MAX_FILE_COMMENTS_IN_BYTES
    ) {
      sendNotification(
        "error",
        intl,
        `${intl.formatMessage({
          id: "asset_exceeds_max_file"
        })}  ${MAX_FILE_COMMENTS_IN_MB} MB`
      );
    }
    this.uploadInputRef.current.value = "";
  };

  onClickUpload = () => {
    const { attachedFile } = this.state;
    const {
      user,
      clientId,
      clientName,
      setIsDoingACommentWithFile
    } = this.props;

    if (attachedFile) {
      setIsDoingACommentWithFile();
      const uploadFileObject = new UploadFile(clientId, clientName, user);
      uploadFileObject
        .checkIsSetAccelerateConfiguration()
        .then(() => {
          uploadFileObject.startUpload(
            attachedFile,
            this.setUploadObject,
            this.onProgressUpload,
            this.onSuccessUploadFile
          );
        })
        .catch(error => {
          console.error("error catch ", error);
        });
    }
  };

  onSuccessUploadFile = file => {
    const {
      handleSubmit,
      unsetIsDoingACommentWithFile,
      isPdfTagActive,
      isAudioTagActive,
      isVideoTagActive,
      versionNumber,
      pdfCarouselIndex
    } = this.props;
    const formattedFile = {
      originalURL: file.futureFileURL,
      type: getFileType(file),
      name: getFileName(file),
      fileSize: file.size,
      fileSizeFormat: file.sizeFormat,
      uuid: file.uuid
    };

    let fileTag = null;
    if (isPdfTagActive) {
      fileTag = { versionNumber, pageNumber: pdfCarouselIndex, type: "pdf" };
    }
    if (isAudioTagActive) {
      // fileTag = { versionNumber, audioTime: audioTime, type: "audio" }
    }
    if (isVideoTagActive) {
      // fileTag = { versionNumber, videoTime: videoTime, type: "video" }
    }

    handleSubmit(formattedFile, fileTag);

    this.cleanAttachedFile();
    unsetIsDoingACommentWithFile();
  };

  onProgressUpload = (file, e) => {
    const { attachedFile } = this.state;
    if (attachedFile.uuid === file.uuid) {
      this.setState((state, props) => {
        const { attachedFile } = state;

        return {
          ...state,
          attachedFile: {
            ...attachedFile,
            state: "inprogress",
            progress: (e.loaded / e.total) * 100
          }
        };
      });
    }
  };

  cancelUpload = () => {
    const { attachedFile } = this.state;
    const { unsetIsDoingACommentWithFile } = this.props;
    attachedFile.uploadObject.abort();
    this.setState(
      (state, props) => {
        return {
          ...state,
          isUploadingFile: false,
          attachedFile: {
            ...state.attachedFile,
            progress: 0,
            state: "waiting",
            uploadObject: null
          }
        };
      },
      () => unsetIsDoingACommentWithFile()
    );
  };
  setUploadObject = (file, uploadObject) => {
    const { attachedFile } = this.state;
    if (attachedFile.uuid === file.uuid) {
      this.setState((state, props) => {
        const { attachedFile } = state;

        return {
          ...state,
          attachedFile: {
            ...attachedFile,
            uploadObject
          }
        };
      });
    }
  }
  hmsToSecondsOnly = (str) => {
    var p = str.split(':'),
        s = 0, m = 1;
    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
  }

  handleOnSubmitcomment = () => {

    const { attachedFile, isUploadingFile } = this.state
    // console.log("isUploading :", isUploadingFile)
    const { handleSubmit, isPdfTagActive,
      isAudioTagActive, isImageTagActive, isVideoTagActive,
      versionNumber, pdfCarouselIndex, imagePoint,imageTagXPer,
      imageTagYPer, imageTagWidth, imageTagHeight, videoTime, audioTime } = this.props
    // audioTime, videoTime
    if (attachedFile === null) {
      if (!isPdfTagActive && !isAudioTagActive && !isVideoTagActive && !isImageTagActive) {
        handleSubmit()
      } else if (isAudioTagActive) {
        const fileTag = { versionNumber, audioTime: this.hmsToSecondsOnly(audioTime) }
        handleSubmit(null, fileTag)
        this.props.unsetIsAudioTagActive()
        // handleSubmit()
      } else if (isVideoTagActive) {
        const fileTag = { versionNumber, videoTime: this.hmsToSecondsOnly(videoTime) }
        handleSubmit(null, fileTag)
        this.props.unsetIsVideoTagActive()
        // handleSubmit()
      } else if (isImageTagActive) { 
        const datapoint = {
          pointX: imageTagXPer * imageTagWidth / 100.0,
          pointY: imageTagYPer * imageTagHeight / 100.0,
          index: imagePoint
        }
        const fileTag = { versionNumber, imagePoint: datapoint }
        handleSubmit(null, fileTag)
        this.props.unsetIsImageTagActive()
      } else {
        const fileTag = { versionNumber, pageNumber: pdfCarouselIndex };
        handleSubmit(null, fileTag);
      }
    } else if (!isUploadingFile) {
      this.setState(
        {
          isUploadingFile: true
        },
        () => {
          this.onClickUpload();
        }
      );
    }
  };

  cleanAttachedFile = () => {
    this.setState({
      attachedFile: null,
      isUploadingFile: false
    })

  }

 

  handleOnClickUploadFile = () => {
    this.uploadInputRef.current.click();
  };

  sendAudioMessage = audioData => {
    if (audioData) {
      const extInfo = audioData.type.split("/");
      const ext = extInfo[1];
      const uuid = uuidv4();
      const s3Name = `${uuid}.${ext}`;

      const newFile = {
        uuid,
        s3Name,
        ext,
        applyRkg: true,
        uploadObject: null,
        file: audioData.blob,
        name: "usuario",
        size: audioData.blob.size,
        sizeFormat: handleFormat(audioData.blob.size),
        type: audioData.type,
        state: "waiting",
        progress: 0
      };

      this.setState({ attachedFile: newFile }, this.onClickUpload);
    }
  };

  handleKeyDown = e => {
    const { comment } = this.props;
    if (!e.shiftKey) {
      if (e.keyCode === KEY_CODE_ENTER && comment.trim()) {
        e.preventDefault();
        this.handleOnSubmitcomment();
      }
    }
  };

  handleKeyDown = e => {
    const { comment } = this.props;
    if (!e.shiftKey) {
      if (e.keyCode === KEY_CODE_ENTER && comment.trim()) {
        e.preventDefault();
        this.handleOnSubmitcomment();
      }
    }
  };

  changeButtonCommentForAudio = op => {
    this.setState({ isRecording: op });
  };

  sendAudio = () => {
    this.audioRef.sendAudio();
  };

  handleShowWriting = () => {
    this.setState({
      isWriting: true
    });
  };

  handleHiddenWriting = () => {
    this.setState({
      isWriting: false
    });
  };

  render() {
    const {
      showPickerEmoji,
      attachedFile,
      isUploadingFile,
      isRecording
    } = this.state;
    const {
      intl,
      canCreateCommentDart,
      saveRecommendedText,
      comment,
      recommendedText,
      userDefaultComments,
      isLoadingCommentText,
      usersMentions,
      isPdfTagActive,
      isAudioTagActive,
      isVideoTagActive,
      isImageTagActive
    } = this.props;
    const { isWriting } = this.state;

    return (
      <div>
        <input
          type="file"
          onChange={this.handleSelectFile}
          ref={this.uploadInputRef}
          hidden
        />
        {canCreateCommentDart && (
          <React.Fragment>
            <div>
              {isAudioTagActive && <AudioTag />}
              {isImageTagActive && <ImageTag />}
              {isVideoTagActive && <VideoTagV2 />}
              {isPdfTagActive && <DinamicPdfTag />}
            </div>
            {attachedFile && (
              <AttachedFileProgress
                attachedFile={attachedFile}
                cancelUpload={this.cancelUpload}
                cleanAttachedFile={this.cleanAttachedFile}
                isUploadingFile={isUploadingFile}
              />
            )}
            {isWriting ? (
              <div className="c-answer__block main-button-input">
                <MentionsInput
                  className="dart-input-text"
                  type="textarea"
                  onKeyDown={this.handleKeyDown}
                  placeholder={
                    saveRecommendedText
                      ? intl.formatMessage({ id: "write_text_recommend" })
                      : intl.formatMessage({ id: "write_a_comment" })
                  }
                  value={comment}
                  onChange={this.props.handleCommentTextChange}
                  singleLine={false}
                  ref="commentRef"
                  // autoFocus={isWriting}
                  allowSuggestionsAboveCursor={true}
                >
                  <Mention
                    trigger="@"
                    data={usersMentions}
                    displayTransform={(id, display) => {
                      return display;
                    }}
                    appendSpaceOnAdd={true}
                    onAdd={this.props.onAddMention}
                  />
                </MentionsInput>
                <MainAudioRecorder
                  onRef={ref => (this.audioRef = ref)}
                  sendAudioMessage={this.sendAudioMessage}
                  changeButtonCommentForAudio={this.changeButtonCommentForAudio}
                />
                {recommendedText &&
                  userDefaultComments &&
                  userDefaultComments.length > 0 && (
                    <div
                      className="block-suggestion"
                      onMouseLeave={this.props.closeRecommendedText}
                    >
                      {userDefaultComments &&
                        userDefaultComments.map((r, k) => (
                          <Tag
                            key={`${r.message}-${k}`}
                            className="tag-recommend-text"
                            closable="true"
                            onClose={() => this.props.deleteRecommendedText(r)}
                            onClick={() => this.selectRecommendedText(r, true)}
                            style={{ cursor: "pointer" }}
                            icon={<CloseCircleOutlined spin />}
                          >
                            {r.message}
                          </Tag>
                        ))}
                    </div>
                  )}

                {/* <MainAudioRecorder /> */}

                <div className="c-answer__block-actions">
                  <div className="block-actions">
                    <span
                      className={
                        showPickerEmoji.show && showPickerEmoji.isMain
                          ? "active"
                          : ""
                      }
                      onClick={() => this.changePickerEmojiComments(true)}
                    >
                      <Tooltip placement="top" title="Emojis">
                        <svg
                          width={25}
                          height={24}
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.1201 24C9.74675 24 7.42667 23.2962 5.45328 21.9776C3.47989 20.6591 1.94182 18.7849 1.03357 16.5922C0.125317 14.3995 -0.112323 11.9867 0.350699 9.65892C0.813722 7.33115 1.95661 5.19295 3.63484 3.51472C5.31307 1.83649 7.45127 0.693604 9.77904 0.230582C12.1068 -0.232441 14.5196 0.00519937 16.7123 0.913451C18.905 1.8217 20.7792 3.35977 22.0978 5.33316C23.4163 7.30655 24.1201 9.62663 24.1201 12C24.1201 15.1826 22.8558 18.2348 20.6054 20.4853C18.355 22.7357 15.3027 24 12.1201 24ZM12.1201 1.50001C10.0434 1.50001 8.01335 2.11582 6.28663 3.26957C4.55992 4.42333 3.21411 6.0632 2.41939 7.98183C1.62467 9.90045 1.41673 12.0117 1.82188 14.0485C2.22702 16.0853 3.22705 17.9562 4.6955 19.4246C6.16395 20.8931 8.03487 21.8931 10.0717 22.2982C12.1085 22.7034 14.2197 22.4955 16.1383 21.7007C18.0569 20.906 19.6968 19.5602 20.8505 17.8335C22.0043 16.1068 22.6201 14.0767 22.6201 12C22.6201 9.21523 21.5139 6.54451 19.5447 4.57538C17.5756 2.60625 14.9049 1.50001 12.1201 1.50001Z"
                            fill="#0096D6"
                          />
                          <path
                            d="M11.3701 9.75H9.87012C9.87012 9.35217 9.71208 8.97064 9.43078 8.68934C9.14947 8.40804 8.76794 8.25 8.37012 8.25C7.97229 8.25 7.59076 8.40804 7.30946 8.68934C7.02815 8.97064 6.87012 9.35217 6.87012 9.75H5.37012C5.37012 8.95435 5.68619 8.19129 6.2488 7.62868C6.81141 7.06607 7.57447 6.75 8.37012 6.75C9.16577 6.75 9.92883 7.06607 10.4914 7.62868C11.054 8.19129 11.3701 8.95435 11.3701 9.75Z"
                            fill="#0096D6"
                          />
                          <path
                            d="M18.8701 9.75H17.3701C17.3701 9.35217 17.2121 8.97064 16.9308 8.68934C16.6495 8.40804 16.2679 8.25 15.8701 8.25C15.4723 8.25 15.0908 8.40804 14.8095 8.68934C14.5282 8.97064 14.3701 9.35217 14.3701 9.75H12.8701C12.8701 8.95435 13.1862 8.19129 13.7488 7.62868C14.3114 7.06607 15.0745 6.75 15.8701 6.75C16.6658 6.75 17.4288 7.06607 17.9914 7.62868C18.554 8.19129 18.8701 8.95435 18.8701 9.75Z"
                            fill="#0096D6"
                          />
                          <path
                            d="M12.1201 18.75C10.5288 18.75 9.00269 18.1179 7.87748 16.9926C6.75226 15.8674 6.12012 14.3413 6.12012 12.75H7.62012C7.62012 13.9435 8.09422 15.0881 8.93814 15.932C9.78205 16.7759 10.9266 17.25 12.1201 17.25C13.3136 17.25 14.4582 16.7759 15.3021 15.932C16.146 15.0881 16.6201 13.9435 16.6201 12.75H18.1201C18.1201 14.3413 17.488 15.8674 16.3628 16.9926C15.2375 18.1179 13.7114 18.75 12.1201 18.75Z"
                            fill="#0096D6"
                          />
                        </svg>
                      </Tooltip>
                    </span>
                    <span
                      className={
                        isLoadingCommentText
                          ? "active heartbeat"
                          : saveRecommendedText
                          ? "active"
                          : ""
                      }
                      onClick={() => this.props.showSaveRecommendedText()}
                      style={{ display: "inline-block" }}
                    >
                      <Tooltip
                        placement="top"
                        title={intl.formatMessage({
                          id: "create_text_recommend"
                        })}
                      >
                        <svg
                          width={25}
                          height={24}
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="slide-bck-center"
                        >
                          <path
                            d="M12.1307 24C8.92496 24 5.91211 22.752 3.64582 20.4849C-0.0587499 16.7811 -0.938178 11.1643 1.45668 6.51C1.67354 6.08914 2.18954 5.92371 2.61125 6.13971C3.03211 6.35571 3.19839 6.87257 2.98154 7.29429C0.928679 11.2843 1.68211 16.098 4.85782 19.2729C6.80011 21.216 9.38268 22.2857 12.1307 22.2857C14.8778 22.2857 17.4613 21.216 19.4035 19.2729C21.3458 17.3297 22.4164 14.7471 22.4164 12C22.4164 9.252 21.3467 6.66943 19.4035 4.72714C17.4604 2.78486 14.8787 1.71429 12.1307 1.71429C9.38268 1.71429 6.80011 2.78486 4.85782 4.72714C4.52268 5.06229 3.98096 5.06229 3.64582 4.72714C3.31068 4.392 3.31068 3.85029 3.64582 3.51514C5.91211 1.24886 8.92496 0 12.1307 0C15.3364 0 18.3501 1.24886 20.6155 3.51514C22.8827 5.78143 24.1307 8.79429 24.1307 12C24.1307 15.2049 22.8827 18.2186 20.6155 20.4849C18.3501 22.752 15.3364 24 12.1307 24Z"
                            fill="#0096D6"
                          />
                          <path
                            d="M12.1306 17.1431C11.6574 17.1431 11.2734 16.76 11.2734 16.286V7.71456C11.2734 7.24142 11.6574 6.85742 12.1306 6.85742C12.6037 6.85742 12.9877 7.24142 12.9877 7.71456V16.286C12.9877 16.76 12.6037 17.1431 12.1306 17.1431Z"
                            fill="#0096D6"
                          />
                          <path
                            d="M16.4159 12.8569H7.84445C7.3713 12.8569 6.9873 12.4729 6.9873 11.9997C6.9873 11.5266 7.3713 11.1426 7.84445 11.1426H16.4159C16.8899 11.1426 17.273 11.5266 17.273 11.9997C17.273 12.4729 16.8899 12.8569 16.4159 12.8569Z"
                            fill="#0096D6"
                          />
                        </svg>
                      </Tooltip>
                    </span>
                    <span
                      className={recommendedText ? "active" : ""}
                      onClick={() => this.props.showRecommendedText()}
                    >
                      <Tooltip
                        placement="top"
                        title={intl.formatMessage({
                          id: "show_text_recommend"
                        })}
                      >
                        <svg
                          width={14}
                          height={24}
                          viewBox="0 0 14 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.8103 1H4.12931L1 13.7273H5.07759L2.75 23L12 10.3636H7.35345L12.8103 1Z"
                            stroke="#0096D6"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </Tooltip>
                    </span>
                    <span onClick={() => this.handleOnClickUploadFile()}>
                      <Tooltip
                        placement="top"
                        title={intl.formatMessage({
                          id: "attach_file"
                        })}
                      >
                        {/* <AttachIcon /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="#0096D6"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
                        </svg>
                      </Tooltip>
                    </span>
                  </div>
                  {isRecording ? (
                    <div
                      className="block-actions-button"
                      onClick={this.sendAudio}
                    >
                      {intl.formatMessage({
                        id: "send_audio"
                      })}
                    </div>
                  ) : saveRecommendedText ? (
                    <div
                      className="block-actions-button"
                      onClick={this.props.handleSaveRecommendedText}
                    >
                      {intl.formatMessage({
                        id: "save_title"
                      })}
                    </div>
                  ) : (
                    <div
                      className="block-actions-button"
                      onClick={this.handleOnSubmitcomment}
                    >
                      {intl.formatMessage({
                        id: "createCommentDart_permission"
                      })}
                    </div>
                  )}
                </div>

                {showPickerEmoji.show && showPickerEmoji.isMain && (
                  <div
                    className="dart-picker-emoji"
                    onMouseLeave={this.closeEmojiPicker}
                    onBlur={this.closeAll}
                    tabIndex="1"
                    ref="divdartpickeremoji"
                  >
                    <Picker
                      native={true}
                      darkMode={true}
                      showPreview={true}
                      title={intl.formatMessage({
                        id: "set_emoji"
                      })}
                      emoji="point_up"
                      onSelect={this.addEmojiToComment}
                      color="#70f6ff"
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="c-answer__block main-button-input">
                <input
                  className="dart-input-text"
                  type="text"
                  placeholder={"¿Algún comentario?"}
                  onClick={this.handleShowWriting}
                />
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const obj = {
    userDefaultComments: state.comments.userDefaultComments,
    isLoadingCommentText: state.comments.isLoadingCommentText,
    user: state.authUser.user,
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : "",
    isPdfTagActive: state.comments.isPdfTagActive,
    isAudioTagActive: state.comments.isAudioTagActive,
    isImageTagActive: state.comments.isImageTagActive,
    isVideoTagActive: state.comments.isVideoTagActive,
    audioTime: state.comments.audioTime,
    videoTime: state.comments.videoTime,
    imagePoint: state.comments.imagePoint,
    imageTagXPer: state.comments.imageTagXPer,
    imageTagYPer: state.comments.imageTagYPer,
    imageTagWidth: state.comments.imageTagWidth,
    imageTagHeight: state.comments.imageTagHeight,
    pdfCarouselIndex: state.comments.pdfCarouselIndex,
    versionNumber: state.comments.itemSelected.document.versionNumber
  };

  return obj;
};

const mapDispatchToProps = {
  setIsDoingACommentWithFile,
  unsetIsDoingACommentWithFile,
  unsetIsImageTagActive,
  unsetIsVideoTagActive,
  unsetIsAudioTagActive
}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MainCommentsTopInput))
);
